module.exports = __webpack_public_path__ + "img/6.efd05b39.png";